module.exports = __webpack_public_path__ + "static/obergeschoss_mini-f311c2988734c5b8fbf8c556e58be7de.png";